import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { z } from 'zod'
import { THIRTY_MB } from '../consts'

/**
 * Return the basic file schema for download files
 */
export const useBaseFileSchema = (): z.ZodType<File> => {
  const { t } = useCustomTranslation()
  const fileSizeLimit = THIRTY_MB

  return z
    .instanceof(File)
    .refine(file => file.size <= fileSizeLimit, {
      message: t('documents.upload.file-size-error'),
    })
    .refine(
      file => {
        const name = file.name.split('.')
        return name[0].length > 3
      },
      {
        message: t('documents.upload.short-name-error'),
      }
    )
    .refine(file => file.name.length < 100, {
      message: t('documents.upload.long-name-error'),
    })
}
